import { AdminPageLayout } from '@/components/admin/AdminPageLayout';
import type { ReactNode } from 'react';

interface AdminTwoPanelLayoutProps {
  title: string;
  description?: string;
  icon?: React.ElementType;
  children?: ReactNode; // Optional if using sidebar/main
  sidebarContent: ReactNode;
  mainContent: ReactNode;
  showBackButton?: boolean;
  backPath?: string;
  backLinkText?: string;
  headerActions?: ReactNode;
  className?: string;
  isSuperAdminPage?: boolean;
  sidebarWidth?: 'narrow' | 'default' | 'equal';
}

export function AdminTwoPanelLayout({
  title,
  description,
  icon,
  sidebarContent,
  mainContent,
  showBackButton = true,
  backPath = '/admin',
  backLinkText = 'Back to Admin Hub',
  headerActions,
  className,
  isSuperAdminPage = true,
  sidebarWidth = 'default',
  children,
}: AdminTwoPanelLayoutProps) {
  const sidebarGridClass = {
    narrow: 'lg:col-span-3',
    default: 'lg:col-span-4',
    equal: 'lg:col-span-6',
  }[sidebarWidth];

  const mainGridClass = {
    narrow: 'lg:col-span-9',
    default: 'lg:col-span-8',
    equal: 'lg:col-span-6',
  }[sidebarWidth];

  return (
    <AdminPageLayout
      title={title}
      description={description}
      icon={icon}
      showBackButton={showBackButton}
      backPath={backPath}
      backLinkText={backLinkText}
      headerActions={headerActions}
      className={className}
      isSuperAdminPage={isSuperAdminPage}
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        <div className={sidebarGridClass}>{sidebarContent}</div>
        <div className={mainGridClass}>{mainContent}</div>
      </div>
      {children}
    </AdminPageLayout>
  );
}
